import React, { Component } from 'react';
import BulletChequeBounce from './ChequeBounceBullet.container';
import EmiChequeBounce from './ChequeBounceEmi.container';

class IncomingContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            incomingPageToShow: 'bullet',
        }
    }

    render() {
        const { admin } = this.props
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xs-12 recovery-tabs">
                        <div className="dashboard-tabs">
                            <button className={this.state.incomingPageToShow == 'bullet' ? 'active' : ''} onClick={e => this.buttonActionHandler("bullet")}>Bullet</button>
                            <button className={this.state.incomingPageToShow == 'emi' ? 'active' : ''} onClick={e => this.buttonActionHandler("emi")}>Emi</button>
                        </div>
                    </div>
                </div>
                {this.state.incomingPageToShow == 'bullet' ?
                    <BulletChequeBounce
                    admin={admin} />
                    : this.state.incomingPageToShow == 'emi' ?
                        <EmiChequeBounce
                        admin={admin} />
                        : null}
            </div>
        )
    }

    buttonActionHandler(type) {
        this.setState({
            incomingPageToShow: type
        })
    }

}


export default IncomingContainer;